var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcShareStop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4.25,
    width: 18,
    height: 13,
    rx: 3,
    stroke: "#151618",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4705 21.75H8.52973C7.80362 21.75 7.45305 20.8606 7.9839 20.3651L10.2503 18.25H13.7503L16.0164 20.3652C16.5472 20.8606 16.1966 21.75 15.4705 21.75Z",
    fill: "#151618"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.978 9.50407L13.9255 7.55133C14.2597 7.21623 14.8015 7.21623 15.1357 7.55133C15.47 7.88651 15.47 8.43 15.1357 8.76518L13.1884 10.7177L15.2001 12.7348C15.5344 13.07 15.5344 13.6135 15.2001 13.9487C14.8659 14.2838 14.3241 14.2838 13.9899 13.9487L11.978 11.9314L10.0117 13.903C9.67748 14.2381 9.13569 14.2381 8.80149 13.903C8.46721 13.5678 8.46721 13.0244 8.80149 12.6892L10.7676 10.7177L8.86586 8.81083C8.53159 8.47565 8.53159 7.93216 8.86586 7.59698C9.20006 7.26188 9.74186 7.26188 10.0761 7.59698L11.978 9.50407Z",
    fill: "#151618"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcShareStop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-share-stop.a716f407fec9a9327aaef678580f500d.svg";